import React from 'react'
import './Loader.css';
import {useGlobalSpinnerContext} from './useloader'
export const Loader = () => {
const isGlobalSpinnerOn = useGlobalSpinnerContext()
    return  isGlobalSpinnerOn ? (
        <div className="loader-container">
        <span className="load"></span>
        </div>
    ): null
}
